import React from 'react';
import { Undo2, Redo2, Save, Download, ChevronLeft, Menu, Settings } from 'lucide-react';

interface ProTopBarProps {
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  isNested: boolean;
  onNavigateUp: () => void;
  currentProjectName: string;
  historyIndex: number;
  historyLength: number;
  onUndo: () => void;
  onRedo: () => void;
  onManualSave: () => void;
  onOpenExport: () => void;
  inspectorOpen: boolean;
  onToggleInspector: () => void;
}

export const ProTopBar: React.FC<ProTopBarProps> = ({
  onToggleSidebar,
  isNested,
  onNavigateUp,
  currentProjectName,
  historyIndex,
  historyLength,
  onUndo,
  onRedo,
  onManualSave,
  onOpenExport,
  onToggleInspector,
}) => {
  return (
    <div className="pro-toolbar">
      <div className="pro-toolbar__left">
        <button
          className="pro-btn pro-btn--icon"
          onClick={onToggleSidebar}
          title="Toggle sidebar"
        >
          <Menu size={16} />
        </button>

        {isNested && (
          <button className="pro-btn pro-btn--ghost" onClick={onNavigateUp}>
            <ChevronLeft size={14} />
            <span>Retour</span>
          </button>
        )}

        <input
          className="pro-toolbar__project-name"
          value={currentProjectName}
          readOnly
          title={currentProjectName}
        />
      </div>

      <div className="pro-toolbar__center">
        <button
          className={`pro-btn pro-btn--icon ${historyIndex <= 0 ? 'pro-btn--disabled' : ''}`}
          onClick={onUndo}
          title="Annuler (⌘Z)"
        >
          <Undo2 size={15} />
        </button>
        <button
          className={`pro-btn pro-btn--icon ${historyIndex >= historyLength - 1 ? 'pro-btn--disabled' : ''}`}
          onClick={onRedo}
          title="Refaire (⌘⇧Z)"
        >
          <Redo2 size={15} />
        </button>
      </div>

      <div className="pro-toolbar__right">
        <button
          className="pro-btn pro-btn--icon pro-btn--save-indicator has-unsaved"
          onClick={onManualSave}
          title="Sauvegarder (⌘S)"
        >
          <Save size={15} />
        </button>

        <button
          className="pro-btn pro-btn--primary"
          onClick={onOpenExport}
          title="Exporter (⌘E)"
        >
          <Download size={14} />
          <span>Export</span>
        </button>

        <button
          className="pro-btn pro-btn--icon"
          onClick={onToggleInspector}
          title="Toggle inspector"
        >
          <Settings size={15} />
        </button>
      </div>
    </div>
  );
};

